import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { filter, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequestStatus } from 'ngxs-requests-plugin';
import { ExtraOptionsService } from '../services/extra-options.service';

export const GetExtraOptionsResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const extraOptionsService = inject(ExtraOptionsService);
  if (!!extraOptionsService.getExtraOptionsSnapshot()?.length) {
    return true;
  }
  extraOptionsService.getExtraOptions();
  return extraOptionsService.getExtraOptionsRequestState$.pipe(
    filter(({loaded, status}) => loaded && status === RequestStatus.Success),
    take(1),
    map(res => {
      return res.data;
    })
  );
}
